import { useDisplayVariant } from 'modules/productDetail'
import * as React from 'react'
import styled from 'styled-components'
import Button from 'theme/atoms/Button'
import { useModal, usePDPSizeTableOpen } from 'modules/ui'
import useTranslations from 'hooks/useTranslations'
import Ruler from 'assets/ruler.svg'
import { Props } from './types'
import ModalContent from './ModalContent'
import useExpectedSizeChartAttributes from './ProductSizes/hooks/useExpectedSizeChartAttributes'
import theme from 'theme'

export default function SizeTable(props: Props) {
  const variant = useDisplayVariant()
  const modal = useModal()
  const { open: pdpSizeTableOpen, setOpen: setPdpSizeTableOpen } =
    usePDPSizeTableOpen()
  const expectedSizeChartAttributes = useExpectedSizeChartAttributes()

  React.useEffect(() => {
    if (pdpSizeTableOpen) {
      setupModal()
    } else {
      modal.setContent(null)
    }
  }, [pdpSizeTableOpen])

  React.useEffect(() => {
    if (!modal.content) {
      // The modal where the size table is located was closed in some way.
      // Synchronize the state.
      setPdpSizeTableOpen(false, props.context)
    }
  }, [modal.content])

  const t = useTranslations<'templates-PDP'>()
  const setupModal = () => {
    if (!variant.data.sizeChartData) {
      modal.setContent(null)
      return
    }

    modal.setContent(
      <ModalContent
        variant={variant}
        context={props.context}
        setPdpSizeTableOpen={setPdpSizeTableOpen}
        sizeChartLogoUrl={variant.data.sizeChartData.sizeChartLogo}
        sizeChartAttributes={expectedSizeChartAttributes}
      />
    )
  }

  if (!variant.data.sizeChartData) return null

  const handleClick = () => {
    setPdpSizeTableOpen(true, props.context)
  }

  return (
    <Wrapper
      className="SizeTable"
      $context={props.context}
      data-cy-collection="SizeTable"
    >
      <Button
        className="size-table-btn"
        variation="secondary"
        $fullWidth={true}
        onClick={() => handleClick()}
        data-cy-handle="size-table-btn"
        data-cy-state="show-size-table"
        title={t.asText(false, 'sizechart_button_title')}
      >
        <Ruler />
        {t('sizeChart_button_label')}
      </Button>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $context: string }>`
  .size-table-btn {
    ${(p) =>
      p.$context === 'Overlay' &&
      'border: none; justify-content: start; padding: 0; padding-left: 0.5rem; color: ' +
        theme.colors.black}
  }
`
